export default {"src":"/_next/static/media/growing_together_01.2f5a3ff4.svg","height":75,"width":95,"blurWidth":0,"blurHeight":0};